var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-control" }, [
    _c("label", [_vm._v(_vm._s(_vm.value.label))]),
    _vm._v(" "),
    _c(
      "select",
      {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.value.value,
            expression: "value.value"
          }
        ],
        ref: "select",
        on: {
          change: [
            function($event) {
              var $$selectedVal = Array.prototype.filter
                .call($event.target.options, function(o) {
                  return o.selected
                })
                .map(function(o) {
                  var val = "_value" in o ? o._value : o.value
                  return val
                })
              _vm.$set(
                _vm.value,
                "value",
                $event.target.multiple ? $$selectedVal : $$selectedVal[0]
              )
            },
            function($event) {
              return _vm.updateSelectFacet()
            }
          ]
        }
      },
      _vm._l(_vm.value.children, function(option, index) {
        return _c("option", { key: index, domProps: { value: option.slug } }, [
          _vm._v(_vm._s(option.name))
        ])
      }),
      0
    ),
    _vm._v(" "),
    _c("span", { staticClass: "bss-icon-chevron-down drop-down-arrow" })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }